module.exports = __webpack_public_path__ + "static/mention_01-3f4be8696876a1ea7c4c8a9c723ef4ba.png";